import { render, staticRenderFns } from "./plan_select_new.vue?vue&type=template&id=20f0c930&scoped=true&lang=pug&"
import script from "./plan_select_new.vue?vue&type=script&lang=js&"
export * from "./plan_select_new.vue?vue&type=script&lang=js&"
import style0 from "./plan_select_new.vue?vue&type=style&index=0&id=20f0c930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f0c930",
  null
  
)

export default component.exports